// extracted by mini-css-extract-plugin
export default {"deals":"DealsBlock_deals__u0844","total":"DealsBlock_total__N3O1a","performed":"DealsBlock_performed__vl9Li"};